module.exports = __webpack_public_path__ + "static/media/testimony2.585ae671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/testimony2.jpg
// module id = 276
// module chunks = 0